import { Colors } from 'cio-design-library/design-tokens'
import { useI18n } from 'builder/hooks/useI18n'
import { Job } from 'builder/modules/jobTracking'

import { AutoTailoringActions } from '../AutoTailoring/AutoTailoringActions'
import { ContactContainer, ContactEmail, ContactText, Container, InfoText } from './styles'

const TRANSLATION = 'builder.job_tracking'
type Props = { job: Job }

export const AutoApplyJobStatusInfo = ({ job }: Props) => {
  const { i18n } = useI18n()

  const getTextColor = () => {
    if (!job.autoApplyStatus) return
    const status = ['error', 'no_application_made', 'information_required', 'auto_tailoring_failed']

    if (status.includes(job.autoApplyStatus)) {
      return Colors.Red50
    }
  }

  const getStatusText = () => {
    const contackKey =
      job?.autoApplyStatus === 'auto_tailoring_failed' ? 'auto_tailor_contact' : 'text'
    return {
      info: i18n.t(`${TRANSLATION}.auto_apply.status_info.${job.autoApplyStatus}`),
      contact: i18n.t(`${TRANSLATION}.contact.${contackKey}`),
    }
  }

  return (
    <Container>
      <InfoText $color={getTextColor()}>{getStatusText().info}</InfoText>
      {job.autoApplyStatus === 'auto_tailoring_failed' && <AutoTailoringActions job={job} />}
      <ContactContainer>
        <ContactText>{getStatusText().contact} </ContactText>
        <ContactEmail href="mailto:autoapply@career.io">
          {i18n.t(`${TRANSLATION}.contact.email`)}
        </ContactEmail>
      </ContactContainer>
    </Container>
  )
}
